import {
  ServerErrorFallbackCard,
  Text,
  Card,
  CardHeader,
} from "@/components/ui";
import type { ExpenseViewModel } from "@/hooks/matter-view-models/use-expenses-view-model";
import type { Matter } from "@/lib/types";
import { ErrorBoundary } from "@sentry/react";
import { ExpenseCard } from "./ExpenseCard";

interface ExpensesCardViewProps {
  expenses: ExpenseViewModel[];
  matter: Matter;
}

function ExpensesCardViewDangerous({
  expenses,
  matter,
}: ExpensesCardViewProps) {
  if (expenses.length === 0) {
    return (
      <Card className="w-full border-2 border-dashed">
        <CardHeader className="space-y-1">
          <Text variant="subHeading" className="text-center">
            No costs found.
          </Text>
        </CardHeader>
      </Card>
    );
  }

  return (
    <div className="flex flex-col gap-y-2">
      {expenses.map((expense) => (
        <ExpenseCard key={expense.id} expense={expense} matter={matter} />
      ))}
    </div>
  );
}

export const ExpensesCardView = (props: ExpensesCardViewProps) => (
  <ErrorBoundary fallback={<ServerErrorFallbackCard />}>
    <ExpensesCardViewDangerous {...props} />
  </ErrorBoundary>
);
